import appData from '@/helpers/app-data'

const state = {
  messages: appData.get('flash_messages') || {}
}

export default {
  namespaced: true,
  state
}



// WEBPACK FOOTER //
// ./frontend/src/store/modules/flashMessages/index.js